var map = {
	"./JackpotPanStart.wav": "333f",
	"./RecvMemo.wav": "e5b5",
	"./fx0248.wav": "bad5",
	"./mtm_receive.wav": "0c2c",
	"./new_goods_buy.wav": "16f2",
	"./new_goods_refund.wav": "a115",
	"./new_message.wav": "6942",
	"./room_enter.wav": "b3c5",
	"./room_out.wav": "0354",
	"./snd_giftout.wav": "812f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b6ca";